import { getApp, getApps, initializeApp } from "firebase/app"
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyC29LlM0hPhcMAdTPH5s_LfW4t0JU1axJY",
  appId: "1:41044257601:web:6718fb32cd2761c847cfc0",
  authDomain: "uag-inventory-by-location.firebaseapp.com",
  databaseURL: "https://uag-inventory-by-location.firebaseio.com",
  messagingSenderId: "41044257601",
  projectId: "uag-inventory-by-location",
  storageBucket: "uag-yotpo-review-images",
}

// Check if Firebase app already exists before initializing
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)
const storage = getStorage(app)

export default () => {
  const createRef = (fileName) => {
    return ref(storage, fileName)
  }

  const uploadFile = async ({ file, fileName }) => {
    const ref = createRef(fileName)

    try {
      await uploadBytes(ref, file)
      const downloadUrl = await getDownloadURL(ref)

      return downloadUrl
    } catch (error) {
      return `Error uploading file: ${error}`
    }
  }

  return {
    uploadFile,
  }
}
